import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Form,
  Image,
  Input,
  Modal,
  Pagination,
  Radio,
  Select,
  Tabs,
} from "antd";
import "../../header/headerWithAuth/HeaderBottomMenu.scss";
import Employer from "../EmployerList/Employer";
// import StudentListTable from '../../studentListTable';
import StudentList from "../StudentList/StudentList";
import "./JobsUnderEvent.scss";
import ErrorIcon from "../../../assets/images/icons/error.svg";
import OfficeIcon from "../../../assets/images/icons/office.svg";
import LocationIcon from "../../../assets/images/icons/location.svg";
import CalendarIcon from "../../../assets/images/icons/calendar.svg";
import HostIcon from '../../../assets/images/icons/host.svg'
import moment from "moment";
import { ControlOutlined } from "@ant-design/icons";
import { getRequest } from "../../../api/http";
import placementOfficer from "../../../api/placementOfficer";
import { LoadingView } from "../../common";
const { TabPane } = Tabs;

function JobsUnderEvent({ eventId }) {
  const [jobs, setJobs] = useState([]);
  const [tabsKey, setTabsKey] = useState("PUBLISH");
  let splitUrl = window.location.pathname.split("/");
  let splitUrlValue = splitUrl[1];
  const [loading, setloading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPage, setJobsPerPage] = useState(5);
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const { Search } = Input;
  const [searchVal, setSearchVal] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState("all");
  const [workingType, setWorkingType] = useState("");
  const [jobUrgency, setJobUrgency] = useState("");
  const [jobType, setJobType] = useState("");
  const [compensationType, setCompensationType] = useState("");

  const [jobStatus, setJobStatus] = useState("");

  const showModal = () => {
    setModalVisible(true);
  };

  const handleOk = () => {
    setModalVisible(false);
    fetchJobs();
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleRadioChange = (e) => {
    setApprovalStatus(e.target.value);
  };

  const onSearch = async (value) => {
    setSearchVal(value);
  };

  useEffect(() => {
    fetchJobs();
  }, [eventId, searchVal]);

  const handleWorkingTypeChange = (value) => {
    setWorkingType(value);
  };

  const handleJobUrgencyChange = (value) => {
    setJobUrgency(value);
  };

  const handleJobTypeChange = (value) => {
    setJobType(value);
  };

  const handleCompensationTypeChange = (value) => {
    setCompensationType(value);
  };

  const fetchJobs = async () => {
    try {
      setloading(true);
      let apiUrl = placementOfficer.getAllJobs(eventId);

      if (searchVal) apiUrl += `searchTerm=${searchVal}&`;
      if (workingType) apiUrl += `workingType=${workingType}&`;
      if (compensationType) apiUrl += `compensationType=${compensationType}&`;
      if (jobType) apiUrl += `jobType=${jobType}&`;
      if (jobUrgency) apiUrl += `jobUrgency=${jobUrgency}&`;

      // Remove parameters if not set
      if (!searchVal) {
        apiUrl = apiUrl.replace(/(searchTerm=[^&]*&?)/, "");
      }
      if (!workingType) {
        apiUrl = apiUrl.replace(/(workingType=[^&]*&?)/, "");
      }
      if (!compensationType) {
        apiUrl = apiUrl.replace(/(compensationType=[^&]*&?)/, "");
      }
      if (!jobType) {
        apiUrl = apiUrl.replace(/(jobType=[^&]*&?)/, "");
      }
      if (!jobUrgency) {
        apiUrl = apiUrl.replace(/(jobUrgency=[^&]*&?)/, "");
      }

      const response = await getRequest(apiUrl);
      setJobs(response.content);
      setloading(false);
    } catch (error) {
      setloading(false);
      console.error("Error fetching jobs:", error);
    }
  };

  const searchFilterContents = (
    <>
      <div className="text-medium small-font-12px spacer-30px">
        Working Type
        <Form.Item name="workingType">
          <Select defaultValue={workingType} onChange={handleWorkingTypeChange}>
            <Select.Option value="WORK_FROM_HOME">Work from Home</Select.Option>
            <Select.Option value="WORK_FROM_OFFICE">
              Work from Office
            </Select.Option>
            <Select.Option value="FLEXIBLE">Flexible</Select.Option>
            <Select.Option value="">None</Select.Option>
          </Select>
        </Form.Item>
      </div>

      <div className="text-medium small-font-12px spacer-30px">
        Job Urgency
        <Form.Item name="JobUrgency">
          <Select defaultValue={jobUrgency} onChange={handleJobUrgencyChange}>
            <Select.Option value="HIGH">High</Select.Option>
            <Select.Option value="MEDIUM">Medium</Select.Option>
            <Select.Option value="LOW">Low</Select.Option>
            <Select.Option value="">None</Select.Option>
          </Select>
        </Form.Item>
      </div>

      <div className="text-medium small-font-12px spacer-30px">
        Job Type
        <Form.Item name="JobType" className="searchbar">
          <Select defaultValue={jobType} onChange={handleJobTypeChange}>
            <Select.Option value="FULL_TIME">Full time</Select.Option>
            <Select.Option value="PART_TIME">Part time</Select.Option>

            <Select.Option value="INTERNSHIP">Internship</Select.Option>
            <Select.Option value="">None</Select.Option>
          </Select>
        </Form.Item>
      </div>

      <div className="text-medium small-font-12px spacer-30px">
        Compensation Type
        <Form.Item name="Compensation Type" className="searchbar">
          <Select
            onChange={handleCompensationTypeChange}
            defaultValue={compensationType}
          >
            <Select.Option value="HOURLY">Hourly</Select.Option>
            <Select.Option value="WEEKLY">Weekly</Select.Option>
            <Select.Option value="MONTHLY">Monthly</Select.Option>
            <Select.Option value="PROJECT_WISE">Project Wise</Select.Option>
            <Select.Option value="">None</Select.Option>
          </Select>
        </Form.Item>
      </div>
    </>
  );
  if (loading) return <LoadingView message="Loading..." />;
  return (
    <>
      <div className="searchRow studentTableSearch">
        <Search
          allowClear
          placeholder={`Find jobs`}
          onSearch={onSearch}
          enterButton
        />
        <Button
          icon={<ControlOutlined />}
          onClick={showModal}
          className="verficationSearchButton"
          type="primary"
        ></Button>
      </div>
      {jobs.length === 0 ? (
        <div className="errorMsg">
          <Image src={ErrorIcon} preview={false} />
          {tabsKey === "PUBLISH" ? <h4>No Active Jobs</h4> : null}
          {tabsKey === "ON_HOLD" ? <h4>No Jobs on Hold</h4> : null}
          {tabsKey === "ARCHIVE" ? <h4>No Archive Jobs</h4> : null}
          {tabsKey === "DRAFT" ? <h4>No Draft Jobs</h4> : null}
        </div>
      ) : (
        (currentJobs || []).map((job, i) => (
          <div key={i} className="jobsRow" style={{}}>
            <Link to={`/job/${job.id}`} state={{ eventId: eventId }}>
              <div className="jobsHead">
                <div className="jobsHeadCol">
                  <h3>
                    {job.title}
                    {
                      // <small>{job.company}</small>
                    }
                  </h3>
                  <ul>
                    <li>
                      <span>
                        <Image src={OfficeIcon} preview={false} />
                      </span>
                      <span className="JobInfo">
                        <span className="infoNameType">Working Type</span>
                        <span className="infoNameValue">
                          {job.workingType === "WORK_FROM_OFFICE"
                            ? "Work from office"
                            : job.workingType === "WORK_FROM_HOME"
                            ? "Work from home"
                            : "Flexible"}
                        </span>
                      </span>
                    </li>
                    <li>
                      <span>
                        <Image src={LocationIcon} preview={false} />
                      </span>
                      <span className="JobInfo">
                        <span className="infoNameType">Location</span>
                        <span className="infoNameValue">
                          <span>{job.city !== null ? job.city : "-"}</span>
                        </span>
                      </span>
                    </li>
                    <li>
                      <span>
                        <Image src={CalendarIcon} preview={false} />
                      </span>
                      <span className="JobInfo">
                        <span className="infoNameType">
                          Job Submission date
                        </span>
                        <span className="infoNameValue">
                          <span>
                            {job.deadLine !== null
                              ? moment(job.deadLine).format("DD-MM-YYYY")
                              : "-"}
                          </span>
                        </span>
                      </span>
                    </li>
                    <li>
                      <span>
                        <Image src={HostIcon} preview={false} />
                      </span>
                      <span className="JobInfo">
                        <span className="infoNameType">Company</span>
                        <span className="infoNameValue">
                          <span>{job.company}</span>
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </Link>
            <div className="jobsInfo">
              <div
                className={
                  jobs.id ? "jobsInfoCol jobsInfoColWidth" : "jobsInfoCol"
                }
              >
                {job.status === "PUBLISH" ? (
                  <ul>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "APPLIED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "applicant"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Applied
                        </span>
                        <span
                          style={
                            splitUrlValue === "applicant"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.applied}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "SHORTLISTED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "shortlisted"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Shortlisted
                        </span>
                        <span
                          style={
                            splitUrlValue === "shortlisted"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.shortlisted}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "OFFERED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "offered"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Offered
                        </span>
                        <span
                          style={
                            splitUrlValue === "offered"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.offered}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "REJECTED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "rejected"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Rejected
                        </span>
                        <span
                          style={
                            splitUrlValue === "rejected"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.rejected}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "VIEWED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "view"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Viewed
                        </span>
                        <span
                          style={
                            splitUrlValue === "view"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.viewed}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "IN_REVIEW" }}
                      >
                        <span
                          style={
                            splitUrlValue === "onHold"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          On Hold
                        </span>
                        <span
                          style={
                            splitUrlValue === "onHold"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.inReview}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "OFFER_ACCEPTED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "offer-accepted"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Offer Accepted
                        </span>
                        <span
                          style={
                            splitUrlValue === "offer-accepted"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.offerAccepted}]
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/status/${job.id}`}
                        state={{ jobDetails: job, status: "OFFER_REJECTED" }}
                      >
                        <span
                          style={
                            splitUrlValue === "offer-rejected"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          Offer Rejected
                        </span>
                        <span
                          style={
                            splitUrlValue === "offer-rejected"
                              ? { color: "#ed9f0b" }
                              : null
                          }
                        >
                          [{job.offerRejected}]
                        </span>
                      </Link>
                    </li>
                  </ul>
                ) : null}
              </div>
            </div>
          </div>
        ))
      )}
      {/* <Pagination
        defaultCurrent={1}
        current={currentPage}
        total={jobs.length}
        pageSize={jobsPerPage}
        onChange={paginate}
      /> */}
      <Modal
        title="Filters"
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            Ok
          </Button>,
        ]}
      >
        {searchFilterContents}
      </Modal>
    </>
  );
}

export default JobsUnderEvent;
